<template>
  <v-container tag="main">
    <galleries-list />
    <v-divider inset/>
    <a-upload-section  class="gallery-upload-section"/>
  </v-container>
</template>

<script>
import GalleriesList from './GalleriesList'
import AUploadSection from '@/components/shared/AUploadSection'

  export default {
    components: {
      AUploadSection,
      GalleriesList
    },
    name: "index"
  }
</script>

<style scoped>
  .gallery-upload-section {
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Gallery/index.vue